import { render, staticRenderFns } from "./MainLayoutV2.vue?vue&type=template&id=2318cf68&scoped=true&"
import script from "./MainLayoutV2.vue?vue&type=script&lang=js&"
export * from "./MainLayoutV2.vue?vue&type=script&lang=js&"
import style0 from "./MainLayoutV2.vue?vue&type=style&index=0&id=2318cf68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318cf68",
  null
  
)

export default component.exports